import { CCStructureItem } from "../../cclib/types/structure";
import {
  contributionGrid,
  deptEMForm,
  generalCEInstructions,
  instructionsStyling,
  preamble,
  setIsMentorField
} from "../shared/structure";

// Bottom of clinicalStructure's definition has a .map()
// which sets isMentorField to this value.
const ALL_FIELDS_MENTOR = true;

export const clinicalStructure: CCStructureItem[] = [
  ...preamble(
    "ANNUAL COUNSELING MEETING DOCUMENTATION FOR CLINICAL ASSISTANT PROFESSORS AND CLINICAL ASSOCIATE PROFESSORS"
  ),
  {
    type: "header",
    name: "Part 1: School of Medicine form for CLINICIAN EDUCATOR Assistant/Associate Professors"
  },
  ...generalCEInstructions,
  {
    type: "header",
    name: "Assessment of Progress toward Reappointment or Promotion"
  },
  {
    type: "instructions",
    additionalCss: instructionsStyling,
    text: "In advance of this annual counseling meeting, faculty member was provided with <u>a guide to Criteria, Review Process Steps, and Resources</u> aligned with next anticipated reappointment or promotion review."
  },
  {
    type: "check",
    key: "cv_was_reviewed",
    name: "The curriculum vitae for this faculty member was reviewed and discussed."
  },
  {
    type: "instructions",
    additionalCss: instructionsStyling,
    text: "With input from mentors or colleagues in the field, the following key points have been provided to the faculty member regarding progress toward reappointment or promotion in the following areas, including an assessment of the allocation of effort in each area:"
  },
  ...[
    ["Clinical activities", "clinical"],
    ["Scholarship activities", "scholarship"],
    ["Teaching activities", "teaching"],
    ["Administrative activities", "admin"],
    ["Allocation of time (including any planned leave)", "allocation"],
    ["Academic and professional support", "academic"],
    ["Availability of mentors", "avail_mentors"],
    ["Availability of resources", "avail_resources"],
    ["Opportunities for learning", "opp"],
    ["Quality improvement projects", "quality"],
    ["Advocacy activities", "advocacy"],
    ["Mentorship activities", "mentorship"],
    ["Financial issues", "financial"],
    ["Professional Development", "professional"],
    ["Achievement of career goals", "achievement"],
    ["Criteria and timeline for reappointment or promotion", "criteria"],
    ["Personal issues (if applicable)", "personal"],
    ["Professionalism and collegiality", "professionalism"],
    ["Other topics (please describe)", "other"]
  ].map(([title, topic]) => {
    return {
      type: "check",
      name: title,
      key: `topic_${topic}`,
      optional: true
    };
  }),

  {
    type: "paragraph",
    key: "other_topics_describe",
    optional: true
  },
  {
    type: "paragraph",
    key: "following_matters_important",
    text: "<strong>The following matters were identified by me as important in the FACULTY MEMBER'S DEVELOPMENT over the next year</strong> (with input from the faculty member's mentor or colleagues in his/her field)"
  },
  {
    type: "check",
    name: "I confirm that I have discussed progress toward reappointment/promotion with the faculty member.",
    key: "confirm_discussion"
  },
  {
    type: "header",
    name: "Current and Anticipated Proportionality of Contribution"
  },
  ...contributionGrid(),
  {
    type: "paragraph",
    text: "Other, if applicable (specify):",
    key: "contrib_other_paragraph",
    optional: true
  },
  ...deptEMForm(true)
].map((item: CCStructureItem) => setIsMentorField(item, ALL_FIELDS_MENTOR));
